import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of2 _mt-1"
}
const _hoisted_4 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_5 = {
  class: "gfu-grid__cell gfu-6of12",
  "data-qa": "date-field:MinDate"
}
const _hoisted_6 = {
  class: "gfu-grid__cell gfu-6of12",
  "data-qa": "date-field:MaxDate"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_field_label = _resolveComponent("field-label")
  const _component_date_field = _resolveComponent("date-field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['gfu-grid__cell', { 'gfu-1of3': $options.conditionFulfilled, 'gfu-2of3': !$options.conditionFulfilled }]),
        "data-qa": `filtersbox-field:${_ctx.displayName}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(['gfu-grid__cell', { 'gfu-1of1': $options.conditionFulfilled, 'gfu-1of2': !$options.conditionFulfilled }])
          }, [
            _createVNode(_component_option_field, {
              modelValue: _ctx.modelValue[$props.conditionName],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.modelValue[$props.conditionName]) = $event)),
              "display-name": _ctx.displayName,
              options: $options.options,
              small: true,
              "show-placeholder": false,
              "data-qa": `filtersbox-field:${_ctx.displayName}`
            }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "data-qa"])
          ], 2 /* CLASS */),
          (!$options.conditionFulfilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_field_label, {
                  class: "gfu-field__label--gray _mt-1",
                  text: "Range"
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_date_field, {
                      modelValue: _ctx.modelValue[$props.minDateFieldName],
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.modelValue[$props.minDateFieldName]) = $event)),
                      class: "_ma-0",
                      "display-name": "Min date",
                      name: "minDate",
                      "show-label": false,
                      small: true
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gfu-divider gfu-divider--small" }, "to", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_date_field, {
                      modelValue: _ctx.modelValue[$props.maxDateFieldName],
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.modelValue[$props.maxDateFieldName]) = $event)),
                      class: "_ma-0",
                      "display-name": "Max date",
                      name: "maxDate",
                      "show-label": false,
                      small: true
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}